import React, {Fragment} from 'react';

import {useSnackbar} from 'notistack';
import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {Box, Grid, Typography} from '@material-ui/core';

import {Utils} from 'commons';
import {useSpinner} from 'hooks';
import {DocumentServices} from 'services';
import {InferPropTypes} from 'commons/types/Types';
import {SnackbarVariants, Messages, Constants} from 'commons/constants';
import EfeSignaturePad from 'components/efe-signature-pad/EfeSignaturePad';
import {EfeButtonPrimary, EfeErrorMsg, EfeLink} from 'components';
import {DigitalizedSignatureValues} from 'commons/models/modules/content/DigitalizedSignatureValues';

SignatureInnerForm.propTypes = {};

/* eslint-disable react/jsx-handler-names */
function SignatureInnerForm(
    props: InferPropTypes<
        typeof SignatureInnerForm.propTypes & FormikProps<DigitalizedSignatureValues>
    >
) {
    const {isSubmitting, setFieldValue, values, errors} = props;
    const {enqueueSnackbar} = useSnackbar();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    function setSignature(signature: string) {
        setFieldValue('signature', signature);
    }

    async function onDownload(doc: string) {
        try {
            setIsLoading(true);
            const response = await DocumentServices.getDocument(doc);
            Utils.functions.downloadDocs(response, `${doc}.pdf`);
            enqueueSnackbar(Messages.FILE_DOWNLOAD_OK, {
                variant: SnackbarVariants.SUCCESS,
            });
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            enqueueSnackbar(Messages.FILE_DOWNLOAD_ERROR, {
                variant: SnackbarVariants.ERROR,
            });
        }
    }

    return (
        <Fragment>
            {isLoading && useSpinner(isLoading)}

            <Form noValidate>
                <Grid item xs={12}>
                    <Typography variant={'body1'}>
                        {'Acepta el '}
                        <EfeLink
                            bold={true}
                            variant='body1'
                            color='primary'
                            underline='always'
                            onClick={() => {
                                onDownload(Constants.DOC_CONTRACT_PREVIEW);
                            }}
                            content={'contrato'}
                        />
                        {' del servicio firmando el siguiente recuadro: '}
                    </Typography>
                    <EfeSignaturePad
                        title={''}
                        description={''}
                        signature={values.signature}
                        setSignature={setSignature}
                        readonly={false}
                    />
                </Grid>
                {errors.signature && <EfeErrorMsg message={errors.signature} />}

                <Grid container direction='row' justifyContent='flex-end'>
                    <Box pt={6} m={2}>
                        <EfeButtonPrimary
                            fullWidth
                            disabled={isSubmitting}
                            type='submit'
                            endIcon={<CallMade />}>
                            {'Ok'}
                        </EfeButtonPrimary>
                    </Box>
                </Grid>
            </Form>
        </Fragment>
    );
}

export default SignatureInnerForm;
